<template>
	<div class="lnb-exist">
		<div class="lnb-wrap">
			<div class="lnb-tit"><b-icon-gear-fill />시스템관리</div>
			<ul class="lnb-list">
				<li class="lnb-list--item">
					<button
						type="button"
						class="btn tit"
						v-bind:class="{
							active:
								currentRouteName == 'SystemAdmin1' ||
								currentRouteName == 'SystemAdmin2' ||
								currentRouteName == 'SystemAdmin18' ||
								currentRouteName == 'SystemAdmin19' ||
								currentRouteName == 'SystemAdmin3' ||
								currentRouteName == 'SystemAdmin4' ||
								currentRouteName == 'SystemAdmin5',
							fold: menuSt1,
						}"
						@click="menuSt1 = !menuSt1"
					>
						설정
					</button>
					<div class="con">
						<router-link
							type="button"
							class="btn menu"
							to="/SystemAdmin"
							v-bind:class="{ active: currentRouteName == 'SystemAdmin1' }"
						>
							물건코드관리
						</router-link>
						<router-link
							type="button"
							class="btn menu"
							to="/SystemAdmin/SystemAdmin2"
							v-bind:class="{ active: currentRouteName == 'SystemAdmin2' }"
						>
							매수고객코드관리
						</router-link>
						<router-link
							type="button"
							class="btn menu"
							to="/SystemAdmin/SystemAdmin18"
							v-bind:class="{ active: currentRouteName == 'SystemAdmin18' }"
						>
							자동보류 제외 관리
						</router-link>
						<router-link
							type="button"
							class="btn menu"
							to="/SystemAdmin/SystemAdmin19"
							v-bind:class="{ active: currentRouteName == 'SystemAdmin19' }"
						>
							KPI·배정 설정
						</router-link>
						<router-link
							type="button"
							class="btn menu"
							to="/SystemAdmin/SystemAdmin3"
							v-bind:class="{ active: currentRouteName == 'SystemAdmin3' }"
						>
							기타설정
						</router-link>
						<router-link
							type="button"
							class="btn menu"
							to="/SystemAdmin/SystemAdmin4"
							v-bind:class="{ active: currentRouteName == 'SystemAdmin4' }"
						>
							약관설정
						</router-link>
						<router-link
							type="button"
							class="btn menu"
							to="/SystemAdmin/SystemAdmin5"
							v-bind:class="{ active: currentRouteName == 'SystemAdmin5' }"
						>
							접속차단관리
						</router-link>
					</div>
				</li>
				<li class="lnb-list--item">
					<button
						type="button"
						class="btn tit"
						v-bind:class="{
							active:
								currentRouteName == 'SystemAdmin6' ||
								currentRouteName == 'SystemAdmin7' ||
								currentRouteName == 'SystemAdmin8',
							fold: menuSt2,
						}"
						@click="menuSt2 = !menuSt2"
					>
						물건관리
					</button>
					<div class="con">
						<router-link
							type="button"
							class="btn menu"
							to="/SystemAdmin/SystemAdmin6"
							v-bind:class="{ active: currentRouteName == 'SystemAdmin6' }"
						>
							작업/변경내역
						</router-link>
						<router-link
							type="button"
							class="btn menu"
							to="/SystemAdmin/SystemAdmin7"
							v-bind:class="{ active: currentRouteName == 'SystemAdmin7' }"
						>
							소유자정보확인
						</router-link>
						<router-link
							type="button"
							class="btn menu"
							to="/SystemAdmin/SystemAdmin8"
							v-bind:class="{ active: currentRouteName == 'SystemAdmin8' }"
						>
							누적매물현황
						</router-link>
					</div>
				</li>
				<li class="lnb-list--item">
					<button
						type="button"
						class="btn tit"
						v-bind:class="{
							active:
								currentRouteName == 'SystemAdmin9' ||
								currentRouteName == 'SystemAdmin10' ||
								currentRouteName == 'SystemAdmin11' ||
								currentRouteName == 'SystemAdmin12' ||
								currentRouteName == 'SystemAdmin20',
							fold: menuSt3,
						}"
						@click="menuSt3 = !menuSt3"
					>
						직원관리
					</button>
					<div class="con">
						<router-link
							type="button"
							class="btn menu"
							to="/SystemAdmin/SystemAdmin9"
							v-bind:class="{ active: currentRouteName == 'SystemAdmin9' }"
						>
							직원현황
						</router-link>
						<router-link
							type="button"
							class="btn menu"
							to="/SystemAdmin/SystemAdmin10"
							v-bind:class="{ active: currentRouteName == 'SystemAdmin10' }"
						>
							직원코드관리
						</router-link>
						<router-link
							type="button"
							class="btn menu"
							to="/SystemAdmin/SystemAdmin20"
							v-bind:class="{ active: currentRouteName == 'SystemAdmin20' }"
						>
							팀 관리
						</router-link>
						<router-link
							type="button"
							class="btn menu"
							to="/SystemAdmin/SystemAdmin11"
							v-bind:class="{ active: currentRouteName == 'SystemAdmin11' }"
						>
							접속·활동이력
						</router-link>
						<router-link
							type="button"
							class="btn menu"
							to="/SystemAdmin/SystemAdmin12"
							v-bind:class="{ active: currentRouteName == 'SystemAdmin12' }"
						>
							관리통계
						</router-link>
					</div>
				</li>
				<li class="lnb-list--item">
					<router-link
						type="button"
						class="btn tit only"
						to="/SystemAdmin/SystemAdmin13"
						v-bind:class="{ active: currentRouteName == 'SystemAdmin13' }"
					>
						입사지원관리
					</router-link>
				</li>
				<li class="lnb-list--item">
					<button
						type="button"
						class="btn tit"
						v-bind:class="{
							active:
								currentRouteName == 'SystemAdmin14' ||
								currentRouteName == 'SystemAdmin15' ||
								currentRouteName == 'SystemAdmin16' ||
								currentRouteName == 'SystemAdmin17',
							fold: menuSt4,
						}"
						@click="menuSt4 = !menuSt4"
					>
						사내운영
					</button>
					<div class="con">
						<router-link
							type="button"
							class="btn menu"
							to="/SystemAdmin/SystemAdmin14"
							v-bind:class="{ active: currentRouteName == 'SystemAdmin14' }"
						>
							게시판설정
						</router-link>
						<router-link
							type="button"
							class="btn menu"
							to="/SystemAdmin/SystemAdmin15"
							v-bind:class="{ active: currentRouteName == 'SystemAdmin15' }"
						>
							계약설정
						</router-link>
						<router-link
							type="button"
							class="btn menu"
							to="/SystemAdmin/SystemAdmin16"
							v-bind:class="{ active: currentRouteName == 'SystemAdmin16' }"
						>
							회의실·법인차
						</router-link>
						<router-link
							type="button"
							class="btn menu"
							to="/SystemAdmin/SystemAdmin17"
							v-bind:class="{ active: currentRouteName == 'SystemAdmin17' }"
						>
							문자발송
						</router-link>
					</div>
				</li>
			</ul>
		</div>
		<router-view></router-view>
	</div>
</template>

<script>
export default {
	name: 'SystemAdmin',
	components: {},
	computed: {
		currentRouteName() {
			return this.$route.name;
		},
	},
	data() {
		return {
			menuSt1: true,
			menuSt2: false,
			menuSt3: false,
			menuSt4: false,
		};
	},
	methods: {
		// onClickToggleFold(st) {
		// 	if (st == 1) {
		// 		this.menuSt1 = !this.menuSt1;
		// 	} else if (st == 2) {
		// 		this.menuSt2 = !this.menuSt2;
		// 	} else if (st == 3) {
		// 		this.menuSt2 = !this.menuSt3;
		// 	}
		// },
	},
};
</script>

<style></style>
